import * as z from "zod";
import { REVIEW_INTERRUPTIONS } from "./reviewRun";

const ReviewInterruptionMetadata = z.object({
  child_session_id: z.string(),
  repository: z.string().nullable(),
  pr_url: z.string(),
  pr_number: z.number(),
  head_sha: z.string().nullable().optional().default(null),
  local: z.boolean().optional(),
  interrupted: z.enum(REVIEW_INTERRUPTIONS),
});

export type ReviewInterruptionMetadata = z.infer<
  typeof ReviewInterruptionMetadata
>;

const parsedByRaw = new WeakMap<object, ReviewInterruptionMetadata | null>();

export function reviewInterruptionMetadata(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): ReviewInterruptionMetadata | null {
  if (message.role !== "agent") return null;
  const raw = message.metadata?.review_interruption;
  if (typeof raw !== "object" || raw === null || Array.isArray(raw)) {
    return null;
  }

  let parsed = parsedByRaw.get(raw);
  if (parsed === undefined) {
    const result = ReviewInterruptionMetadata.safeParse(raw);
    parsed = result.success ? result.data : null;
    parsedByRaw.set(raw, parsed);
  }
  return parsed;
}

export function isReviewInterruptionMessage(message: {
  role: string;
  metadata?: Record<string, unknown> | null;
}): boolean {
  return reviewInterruptionMetadata(message) !== null;
}
